import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { cn } from '@/lib/styles';
import type { ServerRenderedEntry } from '@/types/helpers';
import { getColorVariant } from '@/utils/colorMapping';
import { getHeightValue } from '@/utils/heightMapping';
import { getPositionValue } from '@/utils/positionMapping';
export function BannerCard(t0) {
  const $ = _c(28);
  const {
    card,
    cardBackgroundColorVariant,
    borderColorVariant,
    customTitleGap,
    customImageGap
  } = t0;
  let t1;
  if ($[0] !== borderColorVariant || $[1] !== cardBackgroundColorVariant || $[2] !== customImageGap) {
    t1 = cn("flex flex-col relative p-3 lg:p-4 lg:p-4 gap-5 overflow-hidden group rounded-md flex-1 border border-transparent", cardBackgroundColorVariant, borderColorVariant, customImageGap);
    $[0] = borderColorVariant;
    $[1] = cardBackgroundColorVariant;
    $[2] = customImageGap;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== card.image || $[5] !== card.imageHeight || $[6] !== card.imagePosition?.position) {
    t2 = card.image && <div className={cn("w-full relative", getHeightValue(card.imageHeight))}><BasicImage fill={true} component={card.image} className={cn("object-contain", getPositionValue(card.imagePosition?.position, "object"))} /></div>;
    $[4] = card.image;
    $[5] = card.imageHeight;
    $[6] = card.imagePosition?.position;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== customTitleGap) {
    t3 = cn("flex flex-col gap-3 lg:gap-5", customTitleGap);
    $[8] = customTitleGap;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== card.serverProcessedHtmlTitle || $[11] !== card.title) {
    t4 = card.serverProcessedHtmlTitle ? card.serverProcessedHtmlTitle : <CkEditorCSRRenderer variant="textOnly" htmlContent={card.title} defaultTypography="headingMedium" />;
    $[10] = card.serverProcessedHtmlTitle;
    $[11] = card.title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== card.description || $[14] !== card.serverProcessedHtmlDescription) {
    t5 = card.serverProcessedHtmlDescription ? card.serverProcessedHtmlDescription : <CkEditorCSRRenderer variant="textOnly" defaultTypography="bodyMedium" htmlContent={card.description} />;
    $[13] = card.description;
    $[14] = card.serverProcessedHtmlDescription;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== card.hoverAnimation || $[21] !== card.serverProcessedHtmlContent) {
    t7 = card.hoverAnimation && <AppLink href={card.hoverAnimation.link?.href ?? "#"} openExternalInNewTab={card.hoverAnimation.link?.newTab ?? true} className={cn("absolute w-full hover:text-current active:text-current group-hover:translate-y-0 transition-transform duration-300 ease-in-out h-full left-0 top-0 flex flex-col gap-3 rounded-md p-5 lg:translate-y-full opacity-0 lg:opacity-100", getColorVariant(card.hoverAnimation?.backgroundColor?.color, "bg", "neutral-light-500"))}><div className="h-full max-h-full overflow-y-auto">{card?.serverProcessedHtmlContent ? card.serverProcessedHtmlContent : <CkEditorCSRRenderer variant="textOnly" defaultTypography="bodyMedium" htmlContent={card.hoverAnimation?.description} />}</div>{card.hoverAnimation?.icon && <div className={cn("w-full relative h-8")}><BasicImage fill={true} component={card.hoverAnimation?.icon} className="object-contain" /></div>}</AppLink>;
    $[20] = card.hoverAnimation;
    $[21] = card.serverProcessedHtmlContent;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t1 || $[24] !== t2 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={t1}>{t2}{t6}{t7}</div>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}